// LT-545 (LT-536): the downloadable v1 campaign brief template.
//
// The .docx is a static asset under `frontend/public` (generated by
// `scripts/generate_brief_template.py`) and is served at the URL below.
// The upload entry point links to it; the extraction endpoint (LT-550)
// parses the same template's YAML settings block + narrative sections.
export const BRIEF_TEMPLATE_VERSION = 'v1';
export const BRIEF_TEMPLATE_URL = '/brief-templates/campaign-brief-template-v1.docx';
export const BRIEF_TEMPLATE_FILENAME = 'campaign-brief-template-v1.docx';
